import { cn } from '@/lib/utils';
import { ProductState } from '@/types/promoAttribution';

const STATE_CLASS: Record<string, string> = {
  'Standard Price': 'bg-zinc-100 text-zinc-700 border border-zinc-200',
  Promotion: 'bg-amber-100 text-amber-800 border border-amber-200',
  'Promo Data': 'bg-blue-100 text-blue-800 border border-blue-200',
  'Promotion and Promo Data': 'bg-purple-100 text-purple-800 border border-purple-200',
  Mixed: 'bg-slate-200 text-slate-800 border border-slate-300',
};

export function PromoStateBadge({ state }: { state: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        STATE_CLASS[state as ProductState] ?? STATE_CLASS['Standard Price'],
      )}
    >
      {state}
    </span>
  );
}
